import { StyleSheet, View } from "react-native";
import ContentLoader, { Rect } from "react-content-loader/native";

import { Spacer } from "components/spacer";

const LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT = 200;
const LOCATION_DETAIL_SKELETON_MOBILE_SPACER_SIZE = 16;

export function LocationDetailsSkeletonMobile() {
  return (
    <View style={styles.mobile}>
      <Spacer size={LOCATION_DETAIL_SKELETON_MOBILE_SPACER_SIZE} />
      <ContentLoader
        speed={2}
        width="100%"
        height={80}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect
          width="100%"
          height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        />
      </ContentLoader>
      <Spacer size={LOCATION_DETAIL_SKELETON_MOBILE_SPACER_SIZE} />
      <ContentLoader
        speed={2}
        width="100%"
        height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect
          width="100%"
          height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        />
      </ContentLoader>
      <Spacer size={LOCATION_DETAIL_SKELETON_MOBILE_SPACER_SIZE} />
      <ContentLoader
        speed={2}
        width="100%"
        height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect
          width="100%"
          height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        />
      </ContentLoader>
      <Spacer size={LOCATION_DETAIL_SKELETON_MOBILE_SPACER_SIZE} />
      <ContentLoader
        speed={2}
        width="100%"
        height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect
          width="100%"
          height={LOCATION_DETAIL_SKELETON_SECTION_MOBILE_HEIGHT}
        />
      </ContentLoader>
    </View>
  );
}

const styles = StyleSheet.create({
  mobile: {
    paddingHorizontal: 16,
  },
});
